import React from "react";
import { Card, FormGroup, Input, Label } from "reactstrap";

const PaymentMethodCard = ({
  paymentOptions,
  paymentMethod,
  setPaymentMethod,
}) => (
  <>
    {paymentOptions.map((option, index) => (
      <Card 
        key={index}
        className="p-3 mb-3 cart__payment_card" style={{border: "1px solid rgba(0, 0, 0, .125)"}}>
        <FormGroup check>
          <Label check className="fs--16 fw--600 text-dark">
            <Input
              type="radio"
              name="payment"
              defaultValue={paymentMethod}
              onChange={() => { setPaymentMethod(option?.methodName) }}
              style={{ "--accent-color": "rgb(215, 24, 40)" }}
            />{" "}
            {option?.displayName}
          </Label>
        </FormGroup>
      </Card>
    ))}
  </>
);

export default PaymentMethodCard;
